module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.7fa2e1d2.mp3";